import { Modal } from '@vzmi/shp_shared_compo'

const ImportRuleModal = props => {
  const {
    visible,
    onCancel,
    ...restProps
  } = props
  return (
    <Modal
      visible={visible}
      onOk={onCancel}
      onCancel={onCancel}
      okText='我知道了'
      className='import-rule-modal'
      cancelButtonVisible={false}
      {...restProps}
    >
      <br />
      匯入的商品，需符合以下條件：
      <br />
      • 新增商品提案已通過審核
      <br />
      • 子站、供應商、倉別、配送方式、規格表需與賣場相同
      <br />
      • 成本需與賣場商品相同
      <br />
      • 若為快倉商品，必須已入倉(有備貨數量)
      <br />
      • 無選項商品可增加到所有賣場
      <br />
      • 有選項商品，單層只能增加到單層賣場
      <br />
      • 有選項商品，雙層只能增加到雙層賣場
    </Modal>
  )
}

export default ImportRuleModal
